module.exports = __webpack_public_path__ + "img/simonsays.29551f96.png";